<template>
  <el-dialog :visible.sync="visible" class="editDialog" :title="title" :close-on-click-modal="false" @close="close" @open="getOpen">
    <el-form :model="detail" class="addDetail" :rules="(status != 'readonly') ? rules : {}" ref="detail" label-width="110px">
      <el-form-item label="消防系统" prop="fireControlSystem">
        <el-select :popper-append-to-body="false" v-model="detail.fireControlSystem" placeholder="请选择消防系统" clearable v-if="status != 'readonly'" @change="selectSystem">
          <el-option v-for="item in systemList" :key="item.id" :label="item.name" :value="item.name"></el-option>
        </el-select>
        <p v-else>{{ detail.fireControlSystem }}</p>
      </el-form-item>
      <el-form-item label="设备类型" prop="deviceType">
        <el-select :popper-append-to-body="false" v-model="detail.deviceType" placeholder="请选择设备类型" clearable v-if="status != 'readonly'" @change="selectDevice">
          <el-option v-for="item in deviceList" :key="item.id" :label="item.deviceType" :value="item.deviceType"></el-option>
        </el-select>
        <p v-else>{{ detail.deviceType }}</p>
      </el-form-item>
      <el-form-item label="部门" prop="deptId">
        <el-select :popper-append-to-body="false" v-model="detail.deptId" placeholder="请选择部门" v-if="status != 'readonly'">
          <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <p v-else>{{ detail.deptName }}</p>
      </el-form-item>
      <el-form-item label="区域" prop="areaName">
        <el-input placeholder="请选择区域" v-model="detail.areaName" v-if="status != 'readonly'" @focus="areaTreeVisible = true"></el-input>
        <p v-else>{{ detail.areaName }}</p>
        <selectRegion :hasChildNodes="areaTreeMode" :dialogVisible="areaTreeVisible" @regionTreeClose="areaTreeVisible = false" @regionTreeData="selRegionData" :deptId="detail.deptId">
        </selectRegion>
      </el-form-item>
      <el-form-item label="具体位置" prop="position">
        <el-input placeholder="请输入具体位置" v-model="detail.position" v-if="status != 'readonly'">
        </el-input>
        <p v-else>{{ detail.position }}</p>
      </el-form-item>
      <el-form-item label="设备编号" prop="deviceCode">
        <el-input placeholder="请输入设备编号" v-model="detail.deviceCode" v-if="status != 'readonly'">
        </el-input>
        <p v-else>{{ detail.deviceCode }}</p>
      </el-form-item>
      <el-form-item label="设备名称">
        <el-input placeholder="" v-model="deviceName" v-if="status != 'readonly'" disabled></el-input>
        <p v-else>{{ detail.name }}</p>
      </el-form-item>
      <el-form-item label="二维码编号" prop="qrCode">
        <el-input placeholder="请输入二维码编号" v-model="detail.qrCode" v-if="status != 'readonly'">
        </el-input>
        <p v-else>{{ detail.qrCode }}</p>
      </el-form-item>
      <el-form-item label="负责人" prop="contactPerson">
        <el-input placeholder="请输入负责人" v-model="detail.contactPerson" v-if="status != 'readonly'">
        </el-input>
        <p v-else>{{ detail.contactPerson }}</p>
      </el-form-item>
      <el-form-item label="负责人手机号" prop="contactPhone">
        <el-input placeholder="请输入负责人手机号" v-model="detail.contactPhone" v-if="status != 'readonly'">
        </el-input>
        <p v-else>{{ detail.contactPhone }}</p>
      </el-form-item>
      <el-form-item label="厂家名称" prop="factoryName">
        <el-input placeholder="请输入厂家名称" v-model="detail.factoryName" v-if="status != 'readonly'">
        </el-input>
        <p v-else>{{ detail.factoryName }}</p>
      </el-form-item>
      <el-form-item label="到期提醒" prop="expiredNotice">
        <el-select :popper-append-to-body="false" v-model="detail.expiredNotice" placeholder="请选择" v-if="status != 'readonly'" disabled>
          <el-option v-for="item in remindList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <p v-else>{{ detail.expiredNotice | filterRemind }}</p>
      </el-form-item>
      <el-form-item label="出厂日期" prop="productDate" v-if="detail.expiredNotice == 0" key="productDate">
        <el-date-picker v-model="detail.productDate" format="yyyy-MM-dd" type="date" placeholder="请选择出厂日期" style="width: 100%" v-if="status != 'readonly'">
        </el-date-picker>
        <p v-else>{{ detail.productDate }}</p>
      </el-form-item>
      <el-form-item label="有效期(年)" prop="validPeriod" v-if="detail.expiredNotice == 0" key="validPeriod">
        <el-input placeholder="请输入有效期" v-model.number="detail.validPeriod" v-if="status != 'readonly'">
        </el-input>
        <p v-else>{{ detail.validPeriod }}</p>
      </el-form-item>
      <el-form-item label="巡检任务签名" prop="inspectionSign">
        <el-select :popper-append-to-body="false" v-model="detail.inspectionSign" placeholder="请选择" v-if="status != 'readonly'">
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <p v-else>{{ detail.inspectionSign | filterStauts }}</p>
      </el-form-item>
      <el-form-item label="巡检任务图片" prop="inspectionPhoto">
        <el-select :popper-append-to-body="false" v-model="detail.inspectionPhoto" placeholder="请选择" v-if="status != 'readonly'">
          <el-option v-for="item in picStatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <p v-else>{{ detail.inspectionPhoto | filterPicStatus }}</p>
      </el-form-item>
      <el-form-item label="维修任务签名" prop="repairSign">
        <el-select :popper-append-to-body="false" v-model="detail.repairSign" placeholder="请选择" v-if="status != 'readonly'">
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <p v-else>{{ detail.repairSign | filterStauts }}</p>
      </el-form-item>
      <el-form-item label="维修任务图片" prop="repairPhoto">
        <el-select :popper-append-to-body="false" v-model="detail.repairPhoto" placeholder="请选择" v-if="status != 'readonly'">
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <p v-else>{{ detail.repairPhoto | filterStauts }}</p>
      </el-form-item>
      <el-form-item label="维修期限(天)" prop="repairTerm">
        <el-select :popper-append-to-body="false" v-model="detail.repairTerm" placeholder="请选择" v-if="status != 'readonly'">
          <el-option v-for="i in 99" :key="i" :label="i" :value="i"></el-option>
        </el-select>
        <p v-else>{{ detail.repairTerm }}</p>
      </el-form-item>
      <el-form-item label="周期:" prop="taskCycle">
        <el-select :popper-append-to-body="false" v-model="detail.taskCycle" v-if="status != 'readonly'">
          <el-option v-for="item in periodList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <p v-else>{{ detail.taskCycle | filterTaskCycle }}</p>
      </el-form-item>
      <el-form-item label="巡检次数" prop="inspectionFrequency">
        <el-input placeholder="请输入巡检次数" v-model.number="detail.inspectionFrequency" v-if="status != 'readonly'">
        </el-input>
        <p v-else>{{ detail.inspectionFrequency }}</p>
      </el-form-item>
      <el-form-item label="任务生成时间:" prop="generateTime" v-if="detail.taskCycle == 1 || detail.taskCycle == 2">
        <template>
          <el-select v-model="detail.generateTime" multiple placeholder="请选择任务生成时间" v-if="detail.taskCycle == 1 && status != 'readonly'" key="week" :popper-append-to-body="true">
            <el-option v-for="(item, index) in weekList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <p v-else-if="detail.taskCycle == 1 && status == 'readonly'">{{ detail.generateTime | filterWeek }}</p>
        </template>
        <template>
          <el-select v-model="detail.generateTime" multiple placeholder="请选择任务生成时间" v-if="detail.taskCycle == 2 && status != 'readonly' " key="month" :popper-append-to-body="true">
            <el-option v-for="i in 31" :key="'item'+ i" :label="'每月'+ i +'号'" :value="i"></el-option>
          </el-select>
          <p v-else-if="detail.taskCycle == 2 && status == 'readonly'">{{ detail.generateTime | filterMonth }}</p>
        </template>
      </el-form-item>
      <el-form-item label="任务有效期:" prop="taskValidTime">
        <el-time-picker is-range v-model="detail.taskValidTime" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" value-format="HH:mm" format="HH:mm"
          v-if="status != 'readonly'" key="taskValidTime">
        </el-time-picker>
        <p v-else>{{ detail.taskValidTime }}</p>
      </el-form-item>
    </el-form>
    <p style="margin-top: 30px; display: flex; justify-content: flex-end" v-if="status != 'readonly'">
      <button class='w_next_button cancelButton' @click.prevent="cancel">取消</button>
      <button class='w_next_button confirmButton' style="margin-left: 20px" @click.prevent="confirmSubmit">确认</button>
    </p>
  </el-dialog>
</template>

<script>
export default {
  components: {
    selectRegion: () => import('./selectRegion/index')
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'adding'
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      rules: {
        fireControlSystem: [
          { required: true, message: '请选择消防系统', trigger: 'change' }
        ],
        deviceType: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        deptId: [{ required: true, message: '请选择部门', trigger: 'change' }],
        areaName: [{ required: true, message: '请选择区域' }],
        position: [
          { required: true, message: '请输入具体位置', trigger: 'blur' }
        ],
        deviceCode: [
          { required: true, message: '请输入设备编号', trigger: 'blur' }
        ],
        qrCode: [
          { required: true, message: '请输入二维码编号', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (!/^[1]\d{10}$/.test(value)) {
                callback(new Error('手机号格式错误'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        expiredNotice: [
          { required: true, message: '请选择有效期', trigger: 'change' }
        ],
        factoryName: [
          { required: true, message: '请输入厂家名称', trigger: 'blur' }
        ],
        productDate: [
          { required: true, message: '请选择出厂日期', trigger: 'change' }
        ],
        validPeriod: [
          { required: true, message: '有效期不能为空' },
          { type: 'number', message: '有效期必须为数字值' }
        ],
        inspectionSign: [
          { required: true, message: '请选择巡检任务签名', trigger: 'change' }
        ],
        inspectionPhoto: [
          { required: true, message: '请选择巡检任务图片', trigger: 'change' }
        ],
        repairSign: [
          { required: true, message: '请选择维修任务签名', trigger: 'change' }
        ],
        repairPhoto: [
          { required: true, message: '请选择维修任务图片', trigger: 'change' }
        ],
        repairTerm: [
          { required: true, message: '请选择维修期限', trigger: 'change' }
        ],
        taskCycle: [
          { required: true, message: '请选择周期', trigger: 'change' }
        ],
        inspectionFrequency: [
          { required: true, message: '巡检次数不能为空' },
          { type: 'number', message: '巡检次数必须为数字值' },
          {
            pattern: /^([1-9]|[1-9]\d)$/,
            message: '范围在1-99',
            trigger: 'blur'
          }
        ],
        generateTime: [
          { required: true, message: '请选择任务生成时间', trigger: 'change' }
        ],
        taskValidTime: [
          {
            required: true,
            validator: function (rule, value, callback) {
              if (!value) {
                callback(new Error('请选择时间'))
              } else {
                if (value[0] === value[1]) {
                  callback(new Error('开始时间和结束时间不能相同'))
                } else {
                  callback()
                }
              }
            },
            trigger: 'blur'
          }
        ]
      },
      detail: {},
      visible: this.value,
      deviceList: [],
      systemList: [],
      remindList: [
        {
          label: '是',
          value: 0
        },
        {
          label: '否',
          value: 1
        }
      ],
      weekList: [
        {
          label: '周一',
          value: 1
        },
        {
          label: '周二',
          value: 2
        },
        {
          label: '周三',
          value: 3
        },
        {
          label: '周四',
          value: 4
        },
        {
          label: '周五',
          value: 5
        },
        {
          label: '周六',
          value: 6
        },
        {
          label: '周日',
          value: 7
        }
      ],
      departmentList: [],
      statusList: [
        {
          label: '是',
          value: 0
        },
        {
          label: '否',
          value: 1
        }
      ],
      picStatusList: [
        {
          label: '异常需要传图片',
          value: 0
        },
        {
          label: '异常无需传图片',
          value: 1
        }
      ],
      periodList: [
        {
          label: '每日',
          value: 0
        },
        {
          label: '每周',
          value: 1
        },
        {
          label: '每月',
          value: 2
        }
      ],
      areaTreeVisible: false,
      areaTreeMode: false,
      self: null
    }
  },
  watch: {
    value(val) {
      self = this
      this.setCurrentValue(val)
    },
    visible(value) {
      this.$emit('input', value)
    }
  },
  computed: {
    title() {
      if (this.status == 'adding') {
        return '新增'
      } else if (this.status == 'editing') {
        return '编辑'
      } else if (this.status == 'readonly') {
        return '详情'
      }
    },
    deviceName() {
      return `${this.detail.areaName}${this.detail.position}${this.detail.deviceType}`
    }
  },
  methods: {
    setCurrentValue(val) {
      let data = this.data
      if (val) {
        this.getSystemList()
        this.getDepart()
        if (this.status == 'editing') {
          this.detail = data
          let cloneData = _.clone(data)
          if (cloneData) {
            this.$set(
              this.detail,
              'generateTime',
              cloneData.generateTime
                ? cloneData.generateTime.split(',').map(Number)
                : []
            )
          }
          this.$set(
            this.detail,
            'taskValidTime',
            cloneData.taskValidTime ? cloneData.taskValidTime.split('-') : ''
          )
        } else if (this.status == 'adding') {
          this.detail = {}
          this.$set(this.detail, 'areaName', '')
          this.$set(this.detail, 'position', '')
          this.$set(this.detail, 'deviceType', '')
          this.$set(this.detail, 'deviceCode', '')
          this.$set(this.detail, 'inspectionSign', 0)
          this.$set(this.detail, 'inspectionPhoto', 0)
          this.$set(this.detail, 'repairSign', 0)
          this.$set(this.detail, 'repairPhoto', 0)
          this.$set(this.detail, 'repairTerm', 1)
          this.$set(this.detail, 'inspectionFrequency', 1)
          this.$set(this.detail, 'generateTime', [])
        } else {
          this.detail = data
        }
      }
      this.visible = val
    },
    getDepart() {
      this.$axiosget('operation/deptApi/getDeptList').then((res) => {
        this.departmentList = res.data.data[0].children
      })
    },
    selectDevice(e) {
      if (e) {
        let isFrequency = this.deviceList.find(
          (item) => item.deviceType === e
        ).isFrequency
        let contentItemId = this.deviceList.find(
          (item) => item.deviceType === e
        ).id
        this.$set(this.detail, 'expiredNotice', isFrequency)
        this.$set(this.detail, 'contentItemId', contentItemId)
      }
    },
    selectSystem(e) {
      if (e) {
        this.$axiosget('extra/pointInspectContentItem/list', {
          params: {
            fireControlSystem: e
          }
        }).then((res) => {
          this.deviceList = res.data.data
        })
        this.$set(this.detail, 'expiredNotice', undefined)
        this.$set(this.detail, 'deviceType', '')
        this.$set(this.detail, 'contentItemId', undefined)
      }
    },
    getSystemList() {
      this.$axiosget('operation/dictionaryType/queryByKey', {
        params: {
          key: 'pointInspectFireCS'
        }
      }).then((res) => {
        if (res.data.status === '10000') {
          this.systemList = res.data.data ? res.data.data.list : []
        }
      })
    },
    selRegionData(a) {
      this.$set(this.detail, 'areaName', a.name)
      this.$set(this.detail, 'areaId', a.id)
    },
    getOpen() {
      this.$nextTick(() => {
        this.$refs.detail.clearValidate()
      })
    },
    close() {
      this.detail = {}
      this.$nextTick(() => {
        this.$refs.detail.resetFields()
      })
    },
    cancel() {
      this.close()
      this.visible = false
    },
    confirmSubmit() {
      this.$refs.detail.validate((valid) => {
        if (valid) {
          if (this.status == 'adding') {
            this.$axiospost('extra/pointInspectDevice', {
              ...this.detail,
              taskValidTime: this.detail.taskValidTime
                ? this.detail.taskValidTime.join('-')
                : '',
              generateTime: this.detail.generateTime
                ? this.detail.generateTime.join(',')
                : '',
              name: this.deviceName
            }).then((res) => {
              if (res.data.status == '10000') {
                this.$message.success('提交成功')
                this.cancel()
                this.$emit('refresh')
              }
            })
          } else {
            this.$axiosput('extra/pointInspectDevice', {
              ...this.detail,
              taskValidTime: this.detail.taskValidTime
                ? this.detail.taskValidTime.join('-')
                : '',
              generateTime: this.detail.generateTime
                ? this.detail.generateTime.join(',')
                : '',
              name: this.deviceName
            }).then((res) => {
              if (res.data.status == '10000') {
                this.$message.success('修改成功')
                this.cancel()
                this.$emit('refresh')
              }
            })
          }
        }
      })
    }
  },
  filters: {
    filterRemind(value) {
      if (self.visible) {
        let item = self.remindList.find((item) => item.value == value)
        return item ? item.label : ''
      }
    },
    filterStauts(value) {
      if (self.visible) {
        let item = self.statusList.find((item) => item.value == value)
        return item ? item.label : ''
      }
    },
    filterPicStatus(value) {
      if (self.visible) {
        let item = self.picStatusList.find((item) => item.value == value)
        return item ? item.label : ''
      }
    },
    filterTaskCycle(value) {
      if (self.visible) {
        let item = self.periodList.find((item) => item.value == value)
        return item ? item.label : ''
      }
    },
    filterWeek(value) {
      if (self.visible && self.status == 'readonly') {
        let valueArr = value ? value.split(',') : []
        let nameArr = []
        valueArr.forEach((item) => {
          console.log(self.weekList.find((bitem) => bitem.value == item).value)
          if (self.weekList.find((bitem) => bitem.value == item).value) {
            nameArr.push(
              self.weekList.find((bitem) => bitem.value == item).label
            )
          }
        })
        return nameArr.join(',')
      }
    },
    filterMonth(value) {
      if (self.visible && self.status == 'readonly') {
        let valueArr = value ? value.split(',') : []
        let nameArr = []
        valueArr.forEach((item) => {
          if (item) {
            nameArr.push(`每月${item}号`)
          }
        })
        return nameArr.join(',')
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}

.editDialog /deep/ .el-range-editor.el-input__inner {
  padding-top: 0;
  background: #2e3657;

  .el-range-input {
    background: #2e3657;
    color: #fff;
  }

  .el-range-separator {
    color: #fff;
    width: 6%;
  }

  .el-icon-time {
    margin-top: 3px;
  }
}
/deep/ .el-select-dropdown.is-multiple .el-select-dropdown__item.selected,
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover,
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
  background: #262d4a !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/deviceInspect/inspectDeviceManage/addEditDialog.vue